import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 11968A7F-D159-497F-9D97-A25CACD6AE8D
 * name ceiling-light-multiple-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ceiling-light-multiple-outline.svg
 * tags
 * - Home Automation 
 */
export const CeilingLightMultipleOutlineIcon = createSvgIcon(<><path d="M16.76 13L18.76 17H9.24L11.24 13H16.76M15 6H13V11H10L6 19H22L18 11H15V6M16 20C16 21.11 15.11 22 14 22S12 21.11 12 20H16M8.21 10.11L8.76 9H11V2H9V7H6L2 15H5.76L8.21 10.11Z" /></>, 'CeilingLightMultipleOutlineIcon');
export default CeilingLightMultipleOutlineIcon